<template>
  <div>
    <div class="d-flex justify-center" v-if="!searchSucceeded">
      <div class="no-results pa-4" v-if="!searchInProgress">
        <h3>{{ $t('search.noResults.title') }}</h3>
        <span v-if="searchFailed" class="search-error">
          {{ $t('search.noResults.descriptions.failed') }}
        </span>
        <span v-else>
          {{ $t('search.noResults.descriptions.awaiting') }}
        </span>
      </div>
      <v-progress-circular
        indeterminate
        v-else
        :size="30"
        :width="4"
      />
    </div>
    <div class="no-results pa-4" v-if="noRecommendationFound">
      <h3>{{ $t('search.noResults.title') }}</h3>
      <span>
        {{ $t('search.noResults.descriptions.noneFound') }}
      </span>
    </div>
  </div>
</template>
<script>

export default {
  name: 'PromptRecommendationFetcher',
  data: () => ({
    searchFailed: false,
    searchInProgress: false,
    searchSucceeded: false,
    noRecommendationFound: false,
  }),
  methods: {
    async fetch(preparedSearchable) {
      let searchId = '';
      let recommendations = [];
      this.searchFailed = false;
      this.searchInProgress = true;
      this.searchSucceeded = false;
      this.noRecommendationFound = false;

      try {
        const response = await preparedSearchable.fetchResults();
        searchId = response.id;
        recommendations = response.items.map(item => ({
          documentId: item.documentId,
          documentDetails: {
            recommendation: { },
            ...item.document,
            documentType: 'document',
          },
        }));
        this.searchSucceeded = true;
        this.noRecommendationFound = recommendations.length === 0;
      } catch (error) {
        this.searchFailed = true;
        this.searchSucceeded = false;
      }
      this.searchInProgress = false;

      return {
        recommendations,
        searchId,
      };
    },
  },
};
</script>
<style scoped>
.no-results h3 {
  font-weight: 500;
  font-size: 16px;
  padding-bottom: 10px;
}
.no-results {
  color: grey;
  border: 1px solid #E0E0E0;
  font-weight: 400;
  font-size: 12px;
  border-radius: 5px;
  background-color: white;
}
.search-error {
  color: red;
}
</style>
